import { FC } from 'react'
import { BaseEdge, EdgeProps, getSmoothStepPath } from '@xyflow/react'
import { themeColor } from '../../../layout/theme/color'

const WorkflowEdge: FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  selected,
}) => {
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    borderRadius: 20,
  })

  const strokeColor = selected ? themeColor.cyan : themeColor.slate20

  return (
    <>
      <defs>
        <linearGradient
          id={`edge-gradient-${id}`}
          gradientUnits="userSpaceOnUse"
          x1={sourceX}
          y1={sourceY}
          x2={targetX}
          y2={targetY}
        >
          <stop offset="0%" stopColor={strokeColor} stopOpacity={0.3} />
          <stop offset="50%" stopColor={strokeColor} stopOpacity={1} />
          <stop offset="100%" stopColor={strokeColor} stopOpacity={0.3} />
        </linearGradient>
      </defs>
      <BaseEdge
        id={id}
        path={edgePath}
        interactionWidth={14}
        style={{
          stroke: `url(#edge-gradient-${id})`,
          strokeWidth: selected ? 2.5 : 1.5,
          transition: 'stroke-width 0.2s ease',
        }}
      />
      {selected && (
        <path
          d={edgePath}
          fill="none"
          stroke={themeColor.cyan}
          strokeWidth={4}
          strokeOpacity={0.1}
          style={{ filter: 'blur(3px)', pointerEvents: 'none' }}
        />
      )}
      <circle r={3} fill={strokeColor} style={{ pointerEvents: 'none' }}>
        <animateMotion dur="2s" repeatCount="indefinite" path={edgePath} />
      </circle>
    </>
  )
}

export default WorkflowEdge
